import React, { useState, useEffect } from "react";
import Header from "../../Components/Onboarding-Header/header";
import Sidebar from "../../Components/Onboarding.sidebar/onboarding-sidebar";
import { steps, stepsCorporate, stepsTrust } from "../../Constants/config";
import PersonalInfo from "./Steps/personal-info";
import BusinessInfo from "./Steps/business-info";
import ProofInfo from "./Steps/proof-info";
import LinkAccount from "./Steps/link-account";
import CashAccount from "./Steps/cash-account";
import UploadProof from "./Steps/upload-proof";
import ReviewSubmit from "./Steps/review-submit";
import CorporateInfo from "./Corporate-steps/corporate-info";
import DirectorInfo from "./Corporate-steps/directors-info";
import UploadProofCorporate from "./Corporate-steps/upload-proof-corporate";
import ReviewSubmitCorporate from "./Corporate-steps/review-submit-corporate";
import TrustInfo from "./Trust-steps/trust-info";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentStepRedux } from "../../Redux/store/onboardingFormSlice";
import { useToast } from "../../Utils/toastContext";

const stepMapping = {
  PERSONAL_INFORMATION: 1,
  BUSINESS_INFORMATION: 2,
  PROOF_ITS_YOU: 3,
  EXTERNAL_BANKS: 4,
  CASH_ACCOUNTS: 5,
  UPLOAD_PROOF_DOCS: 6,
  REVIEW_AND_SUBMIT: 7,
};
const MultiStepSidebarForm = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const navigate = useNavigate();
  const currentStepRedux = useSelector((state) => state.form.currentStep);
  const [currentStep, setCurrentStep] = useState(Number(currentStepRedux));
  const [currentStepCorporate, setCurrentStepCorporate] = useState(
    Number(currentStepRedux)
  );
  const [currentStepTrust, setCurrentStepTrust] = useState(
    Number(currentStepRedux)
  );
  const applicationType = useSelector(
    (state) => state.accountType.applicationType
  );

  const renderStepContent = () => {
    dispatch(setCurrentStepRedux(currentStep));
    switch (currentStep) {
      case 1:
        return <PersonalInfo setCurrentStep={setCurrentStep} />;
      case 2:
        return <BusinessInfo setCurrentStep={setCurrentStep} />;
      case 3:
        return <ProofInfo setCurrentStep={setCurrentStep} />;
      case 4:
        return (
          <LinkAccount
            setCurrentStep={setCurrentStep}
            applicationType={applicationType}
          />
        );
      case 5:
        return <CashAccount setCurrentStep={setCurrentStep} />;
      case 6:
        return <UploadProof setCurrentStep={setCurrentStep} />;
      case 7:
        return <ReviewSubmit setCurrentStep={setCurrentStep} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentCorporate = () => {
    dispatch(setCurrentStepRedux(currentStepCorporate));
    switch (currentStepCorporate) {
      case 1:
        return <CorporateInfo setCurrentStep={setCurrentStepCorporate} />;
      case 2:
        return <DirectorInfo setCurrentStep={setCurrentStepCorporate} />;
      case 3:
        return (
          <LinkAccount
            setCurrentStep={setCurrentStepCorporate}
            applicationType={applicationType}
          />
        );
      case 4:
        return (
          <CashAccount
            setCurrentStep={setCurrentStepCorporate}
            applicationType={applicationType}
          />
        );
      case 5:
        return (
          <UploadProofCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      case 6:
        return (
          <ReviewSubmitCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentTrust = () => {
    dispatch(setCurrentStepRedux(currentStepTrust));
    switch (currentStepTrust) {
      case 1:
        return <TrustInfo setCurrentStep={setCurrentStepTrust} />;
      case 2:
        return <DirectorInfo setCurrentStep={setCurrentStepTrust} />;
      case 3:
        return (
          <LinkAccount
            setCurrentStep={setCurrentStepTrust}
            applicationType={applicationType}
          />
        );
      case 4:
        return (
          <CashAccount
            setCurrentStep={setCurrentStepTrust}
            applicationType={applicationType}
          />
        );
      case 5:
        return <UploadProofCorporate setCurrentStep={setCurrentStepTrust} />;
      case 6:
        return <ReviewSubmitCorporate setCurrentStep={setCurrentStepTrust} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getOnboardingStatus = async () => {
    try {
      const response = await GetAPIcalls(`/v1/onboarding/status`);
      if (response.status == 200) {
        if (response.data.length > 0) {
          // find first PENDING section
          let targetSection = response.data.find(
            (item) => item.status === "PENDING"
          );

          // if no PENDING found, fallback to first DRAFT
          if (!targetSection) {
            targetSection = response.data.find(
              (item) => item.status === "DRAFT"
            );
          }

          // set current step if section found in mapping
          if (targetSection && stepMapping[targetSection.section]) {
            const stepNumber = stepMapping[targetSection.section];
            setCurrentStep(stepNumber);
            dispatch(setCurrentStepRedux(stepNumber));
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getOnboardingStatus();
  }, []);
  return (
    <div className="min-h-screen">
      <Header
        setCurrentStep={
          applicationType == 1
            ? setCurrentStep
            : applicationType == 2
            ? setCurrentStepCorporate
            : setCurrentStepTrust
        }
      />

      {applicationType == 1 && (
        <div className="flex  h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={steps}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
          <main className="w-full md:w-3/4 md:px-2">{renderStepContent()}</main>
        </div>
      )}
      {applicationType == 2 && (
        <div className="flex h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsCorporate}
            currentStep={currentStepCorporate}
            setCurrentStep={setCurrentStepCorporate}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentCorporate()}
          </main>
        </div>
      )}
      {applicationType == 3 && (
        <div className="flex h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsTrust}
            currentStep={currentStepTrust}
            setCurrentStep={setCurrentStepTrust}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentTrust()}
          </main>
        </div>
      )}
    </div>
  );
};

export default MultiStepSidebarForm;
